import {Field, FormSection} from "redux-form";
import ReduxLabeledInput from "../basics/input/labeled-input/ReduxLabeledInput";
import React from "react";
import {isFiniteNumber} from "../../utils/MathUtils";

export default function ExtraSettlementParams({requiredFields = [], t} = {}) {
    return (
        <FormSection name={"extra"}>
            <Field
                name="Age"
                type="number"
                required={requiredFields.includes("Age")}
                label={t("settings.averageAgeTimeOfSettlement")}
                unit={t("days")}
                component={ReduxLabeledInput}
            />
        </FormSection>
    )
}

export const validateExtraParams = (values, props) => {
    const errors = {};
    const {extra} = values;
    const {requiredFields = [], t} = props;
    if (requiredFields.includes("Age") && !isFiniteNumber(parseInt(extra?.Age))) {
        errors.Age = t("required")
    } else if (isFiniteNumber(parseInt(extra?.Age))) {
        if (extra?.Age <= 0) {
            errors.Age = t(`$t(errors.mustBeAbove) 0`);
        }
        if (extra?.Age >= 5000) {
            errors.Age = t(`$t(errors.mustBeBelow) 5000`);
        }
    }
    return errors;
}

export const extractExtraParams = (values) => {
    return {
        Age: isFiniteNumber(parseInt(values?.extra?.Age)) ? parseInt(values?.extra?.Age) : null,
    };
}
